module.exports = __webpack_public_path__ + "static/media/wz.d73085d4.png";